const messages = {
    menuTitle: 'Materiały',
    common: {
        tooltips: {
            edit: 'Edytuj',
            hide: 'Ukryj',
            addGroup: 'Dodaj grupę'
        },
        priceList: {
            titles: {
                materials: 'Import cennika materiałów',
                papers: 'Import cennika papierów'
            },
            fields: {
                file: 'Plik cennika'
            },
            placeholders: {
                file: 'Wybierz plik'
            },
            actions: {
                cancelUpload: 'Anuluj wysyłanie',
                close: 'Anuluj',
                submit: 'Wyślij'
            },
            errors: {
                fileTooLarge: 'Przekroczono dopuszczalny rozmiar pliku: {size} MB.',
                invalidName: 'Nazwa pliku musi zawierać fragment: {expected}.'
            },
            validationError: 'Formularz zawiera błędy.'
        },
        notifications: {
            fileUploaded: 'Plik został wysłany.',
            uploadCanceled: 'Wysyłanie pliku zostało anulowane.'
        },
        errors: {
            importPriceList: 'Wysłanie pliku nie powiodło się.'
        },
        validation: {
            invalidForm: 'Formularz zawiera błędy.'
        }
    },
    menu: {
        papers: 'Papiery',
        paperGroups: 'Grupy papierów',
        otherMaterials: 'Inne materiały'
    },
    pages: {
        papers: {
            sections: {
                title: 'Papiery',
                actions: {
                    add: 'Dodaj papier',
                    generatePriceList: 'Generuj cennik',
                    importPriceList: 'Importuj cennik'
                },
                filters: {
                    hideInactive: 'Ukryj nieaktywne',
                    groupPlaceholder: 'Grupa papierów...',
                    searchPlaceholder: 'Szukaj...'
                },
                table: {
                    columns: {
                        name: 'Nazwa',
                        group: 'Grupa',
                        coatingType: 'Rodzaj powleczenia',
                        piecePrice: 'Cena za sztukę (zł)',
                        weight: 'Gramatura (g)',
                        prinergy: 'Typ Prinergy',
                        isVisible: 'Czy aktywny?',
                        actions: 'Akcje'
                    }
                }
            },
            dialog: {
                titles: {
                    create: 'Tworzenie papieru',
                    edit: 'Edycja papieru {name}'
                },
                fields: {
                    name: 'Nazwa',
                    group: 'Grupa',
                    coatingType: 'Rodzaj powleczenia',
                    prinergyType: 'Typ Prinergy',
                    weight: 'Gramatura',
                    thickness: 'Grubość',
                    piecePrice: 'Cena za sztukę',
                    isVisible: 'Czy aktywny?'
                },
                actions: {
                    cancel: 'Anuluj',
                    save: 'Zapisz'
                },
                errors: {
                    nameRequired: 'Proszę podać nazwę papieru.',
                    groupRequired: 'Proszę wybrać grupę papieru.',
                    coatingTypeRequired: 'Proszę wybrać rodzaj powleczenia.',
                    weightRequired: 'Proszę podać gramaturę.',
                    weightNumeric: 'Proszę podać poprawną wartość gramatury.',
                    thicknessRequired: 'Proszę podać grubość papieru.',
                    thicknessFormat: 'Proszę podać grubość z maksymalnie 4 miejscami po przecinku.',
                    thicknessGreaterThanZero: 'Grubość musi być większa od 0.',
                    piecePriceFormat: 'Proszę podać poprawną wartość ceny.'
                }
            },
            form: {
                inactiveChip: 'nieaktywna',
                prinergyNone: 'Brak'
            },
            table: {
                noPrinergy: 'Brak'
            },
            notifications: {
                paperSaved: 'Papier został zapisany.',
                priceListGenerated: 'Cennik papierów został wysłany na adres {email}.',
                priceListGeneratedNoEmail: 'Cennik papierów został wygenerowany.'
            },
            errors: {
                fetchPapers: 'Pobranie listy papierów nie powiodło się.',
                fetchPaper: 'Pobranie danych papieru nie powiodło się.',
                savePaper: 'Zapisanie papieru nie powiodło się.',
                fetchCoatingTypes: 'Pobranie rodzajów powleczenia nie powiodło się.',
                fetchPrinergyPaperTypes: 'Pobranie typów Prinergy nie powiodło się.',
                generatePapersPriceList: 'Wygenerowanie cennika papierów nie powiodło się.'
            }
        },
        paperGroups: {
            sections: {
                title: 'Grupy papierów',
                actions: {
                    add: 'Dodaj grupę'
                },
                filters: {
                    hideInactive: 'Ukryj nieaktywne',
                    searchPlaceholder: 'Szukaj...'
                },
                table: {
                    columns: {
                        name: 'Nazwa',
                        isVisible: 'Czy aktywna?',
                        actions: 'Akcje'
                    }
                }
            },
            dialog: {
                titles: {
                    create: 'Tworzenie grupy',
                    edit: 'Edycja grupy {name}'
                },
                fields: {
                    name: 'Nazwa',
                    isVisible: 'Czy aktywna?'
                },
                actions: {
                    cancel: 'Anuluj',
                    save: 'Zapisz'
                },
                errors: {
                    nameRequired: 'Proszę podać nazwę grupy.'
                }
            },
            notifications: {
                paperGroupSaved: 'Grupa papierów została zapisana.'
            },
            errors: {
                fetchPaperGroups: 'Pobranie listy grup papierów nie powiodło się.',
                savePaperGroup: 'Zapisanie grupy papierów nie powiodło się.'
            }
        },
        otherMaterials: {
            sections: {
                title: 'Inne materiały',
                actions: {
                    add: 'Dodaj materiał',
                    generatePriceList: 'Generuj cennik',
                    importPriceList: 'Importuj cennik'
                },
                filters: {
                    hideInactive: 'Ukryj nieaktywne',
                    namePlaceholder: 'Nazwa...',
                    indexPlaceholder: 'Indeks materiałowy...'
                },
                table: {
                    columns: {
                        name: 'Nazwa',
                        index: 'Indeks materiałowy',
                        type: 'Typ materiału',
                        piecePrice: 'Cena netto za jednostkę (zł)',
                        unit: 'Jednostka',
                        isVisible: 'Czy aktywny?',
                        actions: 'Akcje'
                    }
                }
            },
            dialog: {
                titles: {
                    create: 'Tworzenie materiału',
                    edit: 'Edycja materiału {name}'
                },
                fields: {
                    name: 'Nazwa',
                    type: 'Typ',
                    materialIndex: 'Indeks materiałowy',
                    unit: 'Jednostka',
                    productProperties: 'Cechy produktu',
                    piecePrice: 'Cena netto za jednostkę',
                    manualWorkQuantityPerPiece: 'Ilość materiału na 1 sztukę dla prac ręcznych',
                    isVisible: 'Czy aktywny?'
                },
                actions: {
                    cancel: 'Anuluj',
                    save: 'Zapisz'
                },
                errors: {
                    nameRequired: 'Proszę podać nazwę materiału.',
                    typeRequired: 'Proszę wybrać typ materiału.',
                    indexRequired: 'Proszę podać indeks materiałowy.',
                    unitRequired: 'Proszę wybrać jednostkę.',
                    piecePriceFormat: 'Proszę podać cenę w formacie „0,00”.',
                    manualWorkQuantityPerPieceFormat: 'Ilość musi być liczbą całkowitą większą od 0.'
                }
            },
            notifications: {
                materialCreated: 'Materiał został dodany.',
                materialUpdated: 'Materiał został zaktualizowany.',
                priceListGenerated: 'Cennik materiałów został wysłany na adres {email}.',
                priceListGeneratedNoEmail: 'Cennik materiałów został wygenerowany.'
            },
            errors: {
                fetchMaterials: 'Pobranie listy materiałów nie powiodło się.',
                fetchMaterial: 'Pobranie danych materiału {materialId} nie powiodło się.',
                createMaterial: 'Dodanie materiału nie powiodło się.',
                updateMaterial: 'Aktualizacja materiału nie powiodła się.',
                fetchUnitsOfMeasure: 'Pobranie listy jednostek nie powiodło się.',
                fetchMaterialTypes: 'Pobranie typów materiałów nie powiodło się.',
                updateMaterialType: 'Aktualizacja typu materiału nie powiodła się.',
                fetchProductProductionProperties: 'Pobranie cech produktu nie powiodło się.',
                generateMaterialsPriceList: 'Wygenerowanie cennika materiałów nie powiodło się.'
            }
        }
    }
}

export default {
    messages: messages,
    locale: 'pl'
}
